import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DistrictMiniEntity } from '../../domain/entities/DistrictMiniEntity'
import type { DistrictRegionAdminDto } from '@/backend/market/models/DistrictRegionAdminDto'
 
export class DistrictModel extends DistrictMiniEntity {
  constructor(dataDto: DistrictRegionAdminDto) {
    super()
    mapEntityProperties<DistrictModel>(this, dataDto)
  }
}
